import { render, staticRenderFns } from "./_noticeModal.vue?vue&type=template&id=149f242f"
import script from "./_noticeModal.vue?vue&type=script&lang=js"
export * from "./_noticeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports